import { render, staticRenderFns } from "./DemandTable.vue?vue&type=template&id=2f5ac818&scoped=true&"
import script from "./DemandTable.vue?vue&type=script&lang=js&"
export * from "./DemandTable.vue?vue&type=script&lang=js&"
import style0 from "./DemandTable.vue?vue&type=style&index=0&id=2f5ac818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ac818",
  null
  
)

export default component.exports